module.exports = __webpack_public_path__ + "static/media/12_4.e3cc4e71.jpg";